export const arrayOfType = <T>(data: T[] | undefined, Type: { new (...args: never[]): T }): T[] => {
  if (!Array.isArray(data) || !Type?.constructor) {
    return [];
  }

  return data.map((item) => (item instanceof Type ? item : new Type(item as never)));
};
